import { createModule, constants } from "./redux-acron";
import moment from "moment";
import api from "services/api";
import { handlerWrapper, handlerEffects } from "../utils";
import initialState from "../utils/initialState";

export default createModule({
  name: "actionPlans",
  modelName: "actionPlans",

  state: initialState.actionPlans,

  // ------

  handlers: {
    getActionPlansDashboard: (
      state,
      { payload, status = constants.PENDING_STATUS }
    ) => {
      return handlerWrapper("dashboard", state, status, payload);
    },
    getTemplates: (state, { payload, status = constants.PENDING_STATUS }) => {
      return handlerWrapper("templates", state, status, payload);
    },
    getActionPlanDetails: (
      state,
      { payload, status = constants.PENDING_STATUS }
    ) => {
      let newPayload = payload;
      if (payload.data) {
        newPayload.data = payload.data.map(data => ({
          ...data,
          actionPlanActivities: data.actionPlanActivities.map(action => ({
            ...action,
            dateFrom: action.dateFrom
              ? moment(action.dateFrom).format("DD/MM/YYYY HH:mm")
              : null,
            dateTo: action.dateTo
              ? moment(action.dateTo).format("DD/MM/YYYY HH:mm")
              : null
          }))
        }));
      }
      return handlerWrapper("currentActionPlan", state, status, newPayload);
    },
    getIndicators: (state, { payload, status = constants.PENDING_STATUS }) => {
      return handlerWrapper("indicators", state, status, payload);
    },
    addActionPlan: (state, { payload, status = constants.PENDING_STATUS }) => {
      if (payload.data) {
        return handlerWrapper("newAction", state, status, {
          data: { isOk: true }
        });
      }
      return handlerWrapper("newAction", state, status, payload);
    },
    updateProgress: (state, { payload, status = constants.PENDING_STATUS }) => {
      return handlerWrapper("progress", state, status, payload);
    },
    updateStatus: (state, { payload, status = constants.PENDING_STATUS }) => {
      return handlerWrapper("progress", state, status, payload);
    }
  },

  effects: {
    getActionPlansDashboard: {
      callback(actions, { payload }) {
        return handlerEffects(
          api.actionPlans.getActionPlansDashboard,
          payload,
          actions.getActionPlansDashboard
        );
      }
    },
    addActionPlan: {
      callback(actions, { payload }) {
        return handlerEffects(
          api.actionPlans.addActionPlan,
          payload,
          actions.addActionPlan
        );
      }
    },
    updateProgress: {
      callback(actions, { payload }) {
        return handlerEffects(
          api.actionPlans.updateProgress,
          payload,
          actions.updateProgress
        );
      }
    },
    updateStatus: {
      callback(actions, { payload }) {
        return handlerEffects(
          api.actionPlans.updateStatus,
          payload,
          actions.updateStatus
        );
      }
    },
    getTemplates: {
      callback(actions, { payload }) {
        return handlerEffects(
          api.actionPlans.getTemplates,
          payload,
          actions.getTemplates
        );
      }
    },
    getActionPlanDetails: {
      callback(actions, { payload }) {
        return handlerEffects(
          api.actionPlans.getActionPlanDetails,
          payload,
          actions.getActionPlanDetails
        );
      }
    },
    getIndicators: {
      callback(actions, { payload }) {
        return handlerEffects(
          api.actionPlans.getIndicators,
          payload,
          actions.getIndicators
        );
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/modules/ActionPlansModule.js